import { ModalStoreType } from 'src/modules/transferRegistration/types';

import { BooleanStore, AnyStore } from 'stores';

export const openModalStore = new BooleanStore();
export const openConfirmModalStore = new BooleanStore();
export const openDeleteModalStore = new BooleanStore();
export const modalStore = new AnyStore<ModalStoreType>();
